import { useSearchParams } from 'react-router'
import { AccountsPanel } from '../components/admin/accounts/AccountsPanel'
import { CreateUserPanel } from '../components/admin/CreateUserPanel'
import { EnvironmentPanel } from '../components/admin/EnvironmentPanel'
import { InvitesPanel } from '../components/admin/InvitesPanel'
import { PollingPanel } from '../components/admin/PollingPanel'
import { UsersPanel } from '../components/admin/UsersPanel'
import { WatchlistPanel } from '../components/admin/WatchlistPanel'
import { CrashesPanel } from '../components/admin/crashes/CrashesPanel'
import { SupportPanel } from '../components/admin/support/SupportPanel'
import { ADMIN_SECTIONS, adminSection } from '../components/nav/adminSections'

/** One admin section at a time, picked by `?tab=` from the sidebar's Admin group. */
export function AdminScreen() {
	const [params] = useSearchParams()
	const tab = adminSection(params.get('tab'))
	const label = ADMIN_SECTIONS.find((s) => s.value === tab)!.label
	return (
		<div className="stack">
			<div className="page-header">
				<div>
					<div className="eyebrow">Admin</div>
					<h1>{label}</h1>
				</div>
			</div>
			{tab === 'accounts' && <AccountsPanel />}
			{tab === 'support' && <SupportPanel />}
			{tab === 'crashes' && <CrashesPanel />}
			{tab === 'users' && (
				<>
					<InvitesPanel />
					<CreateUserPanel />
					<UsersPanel />
				</>
			)}
			{tab === 'watchlist' && <WatchlistPanel />}
			{tab === 'polling' && <PollingPanel />}
			{tab === 'environment' && <EnvironmentPanel />}
		</div>
	)
}
